import WebcamTurnedOff from "./WebcamTurnedOff";

export default WebcamTurnedOff;